import logo from "@/assets/images/logo/logo.webp";
import FooterLogoLocales from "@/data/localization/FooterLogo.locales";
import { Caption, useLocales } from "@crescentapplications/react-ui";

export default function FooterLogo() {
  const l = useLocales();
  const style: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
  };

  return (
    <div style={style}>
      <a href="/" style={{ textDecoration: "none" }}>
        <img src={logo} alt="Logo" style={{ height: "8rem", width: "8rem" }} />

        <Caption color="always-light" textAlign="center">
          {l(FooterLogoLocales.title)}
        </Caption>
        <Caption color="always-light" textAlign="center">
          {l(FooterLogoLocales.subtitle)}
        </Caption>
      </a>
    </div>
  );
}
